import { useTranslation } from 'react-i18next'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import { blockOptions } from './constants'
import { getBlockOptionChanges } from './helpers'
import * as Styles from './styles'

const BlockOptionsCheckboxes = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const { t } = useTranslation()

  const hasError = errors.some(e => e.type === 'actionBlockOptionsEmpty')

  const handleChangeOption = (option, checked) => {
    onChangeConfig(getBlockOptionChanges(config, option, checked))
  }

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Opciones a bloquear')}</Text>
      <Styles.CheckboxesContainer>
        {blockOptions.map(option => (
          <Checkbox
            key={option.value}
            label={t(option.label)}
            checked={config[option.value] || false}
            onChange={e => handleChangeOption(option.value, e.target.checked)}
            disabled={disabled}
            error={hasError}
          />
        ))}
      </Styles.CheckboxesContainer>
    </Styles.Container>
  )
}

export default BlockOptionsCheckboxes
